module.exports = __webpack_public_path__ + "static/img/bg7.919fd46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg7.png
// module id = GPvA
// module chunks = 0